module.exports = __webpack_public_path__ + "static/media/man_han_wor_org.a2ced4c8.png";